import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ClerkProvider } from "@clerk/react";
import { enUS, roRO, esES, frFR, itIT, ptPT } from "@clerk/localizations";

const CLERK_LOCALES = {
  en: enUS, ro: roRO, fr: frFR, pt: ptPT,
  es: { ...esES, signIn: { ...esES.signIn, start: { ...esES.signIn?.start, title: "Continuar a Ayahuasca Angel", titleCombined: "Continuar a Ayahuasca Angel" } } },
  it: { ...itIT, signIn: { ...itIT.signIn, start: { ...itIT.signIn?.start, title: "Continua su Ayahuasca Angel", titleCombined: "Continua su Ayahuasca Angel" } } },
};
const clerkLocale = (path) => {
  const seg = path.split("/")[1];
  if (CLERK_LOCALES[seg]) localStorage.setItem("aa_locale", seg);
  return CLERK_LOCALES[seg] || CLERK_LOCALES[localStorage.getItem("aa_locale")] || CLERK_LOCALES[(navigator.language || "en").slice(0, 2)] || enUS;
};

const appearance = { variables: { colorPrimary: "#102D29", colorForeground: "#19372F", colorBackground: "#FFFCF6", fontFamily: "Manrope, sans-serif", borderRadius: "14px" } };

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function ClerkAuthProvider({ children }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [config, setConfig] = useState(null);
  const [unavailable, setUnavailable] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const load = async (attempt = 0) => {
      try {
        const cfg = await (await fetch(`${BACKEND_URL}/api/clerk/config`)).json();
        if (cfg.enabled) return cancelled || setConfig(cfg);
      } catch {}
      if (cancelled) return;
      if (attempt >= 20) return setUnavailable(true);
      setTimeout(() => load(attempt + 1), 1500);
    };
    load();
    return () => { cancelled = true; };
  }, []);

  if (unavailable) return <p style={{ padding: 24 }}>Sign-in is unavailable right now. Refresh the page to try again.</p>;
  if (!config) return null;
  return (
    <ClerkProvider
      publishableKey={config.publishable_key}
      proxyUrl={config.proxy_url || undefined}
      appearance={appearance}
      localization={clerkLocale(pathname)}
      routerPush={(to) => navigate(to)}
      routerReplace={(to) => navigate(to, { replace: true })}
      signInUrl="/sign-in"
      signUpUrl="/sign-up"
      signInFallbackRedirectUrl="/"
      signUpFallbackRedirectUrl="/"
      afterSignOutUrl="/"
    >
      {children}
    </ClerkProvider>
  );
}
